<template />
<script>
export default {
  data: function () {
    return {
      updateRulesTimer: null,
      updateSellersTimer: null,
      _sellersPollActive: false
    }
  },
  methods: {
    updateSellers: function () {
      const self = this
      const force = this._sellersPollActive === true
      const loader = this.$root.loadV1Sellers
        ? this.$root.loadV1Sellers(force)
        : this.$http.get('/api/v1/sellers').then(function (response) { return response.body }, function () { return null })
      loader.then(function (body) {
        if (!body) return
        var item = Array.isArray(body.item) ? body.item : []
        if (item.length === 0) {
          if (self.$root.anySellerAccountSetupCompleted) {
            self.$store.dispatch('setSellers', item)
          } else {
            if (self.updateSellersTimer === null) {
              self._sellersPollActive = true
              self.updateSellersTimer = setInterval(self.updateSellers, 1000)
            }
          }
        } else {
          self._sellersPollActive = false
          if (self.updateSellersTimer !== null) {
            clearInterval(self.updateSellersTimer)
            self.updateSellersTimer = null
          }
          self.$store.dispatch('setSellers', item)
        }
      }, function () { /* error is handled globally by http interceptors */ })
    },
  },
  created: function () {
    this.updateSellers()
  },
  beforeDestroy: function () {
    if (this.updateSellersTimer) {
      clearInterval(this.updateSellersTimer)
      this.updateSellersTimer = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// Model.Sellers.vue?18bafc20